import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import { Image, Modal } from 'react-bootstrap-5';

import UserIconList from 'components/user_icon_list';
import { mapName } from 'helpers/react_select_helpers';

export default class IntegrationModal extends React.Component {

  static propTypes = {
    calendar: PropTypes.bool,
    children: PropTypes.node.isRequired,
    currentDatabase: PropTypes.object,
    databases: PropTypes.array,
    disconnectModal: PropTypes.bool,
    shown: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  static defaultProps = {
    calendar: false,
    disconnectModal: false,
    databases: []
  }
  state = {
    database: this.props.currentDatabase
      || (this.props.databases && this.props.databases.length > 0 ? this.props.databases[0] : null),
    disableBtn: false
  }

  getSelectedDatabase = () => {
    const { databases } = this.props;
    const { database } = this.state;

    if (!databases || databases.length === 0) {
      return null;
    }

    const defaultDatabase = databases.length > 0 ? databases[0] : null;

    return database || defaultDatabase || null;
  }

  handleDatabaseSelect = (event) => {
    const { databases } = this.props;
    if (!databases || databases.length === 0) {
      return;
    }
    const selectedId = Number(event.target.value);
    const database = databases.find(db => db.id === selectedId) || databases[0];
    this.setState({ database });
  }

  handleSave = () => {
    const { onSave } = this.props;

    this.setState({ disableBtn: true });
    onSave().then(() => {
      this.setState({ disableBtn: false });
    });
  }

  renderSignInButton = () => {
    const {
      calendar,
      onSave
    } = this.props;
    const database = this.getSelectedDatabase();
    const hasDatabase = Boolean(database && database.id);

    if (calendar) {
      return (
        <Button
          className="p-0 ms-1"
          disabled={!hasDatabase}
          type="button"
          variant="ghost"
          onClick={() => onSave(database.id)}
        >
          <Image
            alt="Sign in with Google"
            className="img-fluid"
            src={'/images/google_integration/btn_google_signin_dark_normal_web.png'}
          />
        </Button>
      );
    } else {
      return (
        <Button disabled={!hasDatabase} label="Save Changes" onClick={() => onSave(database.id)} />
      );
    }
  }

  render() {
    const {
      children,
      disconnectModal,
      shown,
      databases,
      title,
      onCancel
    } = this.props;
    const { disableBtn } = this.state;
    const hasDatabases = databases && databases.length > 0;
    const database = this.getSelectedDatabase();
    const membersCount = database && database.members ? database.members.length : 0;
    const defaultDatabase = hasDatabases ? databases[0] : null;
    const selectedDatabaseId = database && database.id
      ? database.id
      : (defaultDatabase ? defaultDatabase.id : '');
    const databaseText = membersCount === 1 ? 'User' : 'Users';
    const databaseSelectId = 'integration-modal-database-select';

    return (
      <Modal centered show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column">
          {children}
          {disconnectModal ?
            <div className="text-center mt-2">
              <Button
                disabled={disableBtn}
                variant="destructive"
                onClick={this.handleSave}
              >
                {disableBtn ? 'Disconnecting Account...' : 'Disconnect Account'}
              </Button>
            </div> :
            <div className="d-flex flex-column mt-2">
              <label className="form-label fw-semibold mb-1" htmlFor={databaseSelectId}>
                Select Database
              </label>
              {hasDatabases ? (
                <div className="row gx-3 align-items-center">
                  <div className="col-12 col-md-5 m-0">
                    <select
                      className="form-select"
                      id={databaseSelectId}
                      value={selectedDatabaseId}
                      onChange={this.handleDatabaseSelect}
                    >
                      {databases.map((db, index) => (
                        <option key={db.id || index} value={db.id || ''}>
                          {mapName(db)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md m-0">
                    <div className="d-flex flex-wrap align-items-center">
                      <span className="small">
                        {membersCount} {databaseText}
                      </span>
                      {database && database.members && <UserIconList users={database.members}/>}
                    </div>
                  </div>
                </div>
              ) : (
                <p className="mb-0">No databases available.</p>
              )}
            </div>
          }
        </Modal.Body>
        {!disconnectModal &&
          <Modal.Footer className="border-top text-end">
            <Button variant="ghost" onClick={onCancel}>
              Cancel
            </Button>
            {this.renderSignInButton()}
          </Modal.Footer>
        }
      </Modal>
    );
  }
}
